import { FilterSelectionType } from '@/types/filter';
import SingleSelect from '@/storybook/components/FormCollection/SingleSelect/SingleSelect';
import MultiSelect from '@/storybook/components/FormCollection/MultiSelect/MultiSelect';
import TreeSelect from '@/storybook/components/FormCollection/TreeSelect/TreeSelect';
import SingleLevelSelect from '@/storybook/components/FormCollection/SingleLevelSelect/SingleLevelSelect';
import MultiLevelSelect from '@/storybook/components/FormCollection/MultiLevelSelect/MultiLevelSelect';
import CheckboxFilterAdapter from '@/storybook/components/FormCollection/Checkbox/adapters/CheckboxFilterAdapter';
import OldTreeSelect from '@/storybook/components/FormCollection/TreeSelect/OldTreeSelect';
import SingleSelectFloatingLabel from '@/storybook/components/FormCollection/SingleSelect/SingleSelectFloatingLabel';
import MultiSelectFloatingLabel from '@/storybook/components/FormCollection/MultiSelect/MultiSelectFloatingLabel';
import MultiLevelSelectFloatingLabel from '@/storybook/components/FormCollection/MultiLevelSelect/MultiLevelSelectFloatingLabel';
import SingleLevelSelectFloatingLabel from '@/storybook/components/FormCollection/SingleLevelSelect/SingleLevelSelectFloatingLabel';
import TreeSelectFloatingLabel from '@/storybook/components/FormCollection/TreeSelect/TreeSelectFloatingLabel';
import OldTreeSelectFloatingLabel from '@/storybook/components/FormCollection/TreeSelect/OldTreeSelectFloatingLabel';

export const selectComponentsByType: Record<FilterSelectionType, React.ElementType> = {
  dropdown: SingleSelect,
  multiselect: MultiSelect,
  treeselect: TreeSelect,
  oldtreeselect: OldTreeSelect,
  levelselect: SingleLevelSelect,
  multilevelselect: MultiLevelSelect,
  checkbox: CheckboxFilterAdapter,
};

export const selectComponentsByTypeFloatingLabel: Record<FilterSelectionType, React.ElementType | null> = {
  dropdown: SingleSelectFloatingLabel,
  multiselect: MultiSelectFloatingLabel,
  treeselect: TreeSelectFloatingLabel,
  oldtreeselect: OldTreeSelectFloatingLabel,
  levelselect: SingleLevelSelectFloatingLabel,
  multilevelselect: MultiLevelSelectFloatingLabel,
  checkbox: CheckboxFilterAdapter,
};

export const getSelectComponentByType = (type: FilterSelectionType, useFloatingLabel?: boolean): React.ElementType => {
  if (useFloatingLabel) {
    const floatingLabelComponent = selectComponentsByTypeFloatingLabel[type];
    if (floatingLabelComponent) {
      return floatingLabelComponent;
    }
  }
  return selectComponentsByType[type];
};
